// All DOM refs used across modules. Resolved at module evaluation time,
// which is safe because <script type="module"> is deferred until after
// DOMContentLoaded.

function byId<T extends Element>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`DOM element not found: #${id}`);
  return el as unknown as T;
}

export const dom = {
  scene: byId<HTMLDivElement>('scene'),
  world: byId<HTMLDivElement>('world'),
  menuContainer: byId<HTMLDivElement>('menu-container'),
  lines: byId<HTMLCanvasElement>('lines'),
  reticle: byId<HTMLDivElement>('reticle'),
  homeOptionsOverlay: byId<HTMLDivElement>('home-options-overlay'),
  homeOptionsConnector: byId<HTMLDivElement>('home-options-connector'),
  homeOptionsConnectorPath: byId<SVGPathElement>('home-options-connector-path'),
  homeOptionsInputDot: byId<HTMLDivElement>('home-options-input-dot'),
  homeOptionRemove: byId<HTMLDivElement>('home-option-remove'),
  homeOptionEdit: byId<HTMLDivElement>('home-option-edit'),
  launchOverlay: byId<HTMLDivElement>('launch-overlay'),
  lockScreen: byId<HTMLDivElement>('lock-screen'),
  lockLinesOverlay: byId<HTMLCanvasElement>('lock-lines-overlay'),
  relockCapture: byId<HTMLDivElement>('relock-capture'),
};
